<!-- <span [innerHTML]="showText | linky"></span>
<span class="read-more cursor" *ngIf="isShowReadMoreButton"
    (click)="toggleShowHide()">{{ toggleButtonText }}</span> -->
    <span [innerHTML]="text"></span>
